import React from 'react'
import type { ArticleUIData } from '@which/shared'

import classnames from 'classnames'

import { FreeArticleSignup } from '../../pages/article/components/FreeArticleSignup/FreeArticleSignup'
import { renderArticleElements } from './article-element-renderer'

export const articleBodyRenderer = (
  articleBodyTemplate: ArticleUIData[],
  additionalClasses = '',
  additionalInfo?: {
    articleUrl?: string
    subVerticalSlug?: string
    context?: string
    title?: string
    showFreeAccountLock?: boolean
    userLoggedIn?: boolean
  }
) => (
  <div className={classnames('article-wrapper', additionalClasses)}>
    {renderArticleElements(articleBodyTemplate, additionalInfo)}
    {additionalInfo?.showFreeAccountLock && additionalInfo?.articleUrl && (
      <FreeArticleSignup
        loggedIn={additionalInfo?.userLoggedIn}
        articleUrl={additionalInfo.articleUrl}
      />
    )}
  </div>
)
